export default __webpack_public_path__ + "static/media/usdt.194349b2.svg";